module.exports = __webpack_public_path__ + "media/images/content/BTN_enter-01-d1df361b00e80848518fa4924954ef14.svg";